import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSupplies = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M8.333 7V4.333M13 7V3.444c0-.981-.796-1.777-1.778-1.777h-1.11c-.983 0-1.779.796-1.779 1.777v.89M3 7V4.632c0-.482.13-.955.378-1.37l.784-1.31a.59.59 0 0 1 .505-.285v0c.206 0 .398.108.504.286l.784 1.31c.248.414.378.887.378 1.369V7m2-2.667h2M1.667 7h12.666v4a2.667 2.667 0 0 1-2.666 2.667H4.333A2.667 2.667 0 0 1 1.667 11z"
	})
});
export default SvgSupplies;
